import AppVars from "./AppVars.js";

export default class Logger {
    static instance = null;
    currentEnv = null;
    envRanking = ["local", "dev", "test", "stage", "prod"];

    static getInstance(){
        if (Logger.instance == null){
            Logger.instance = new Logger();
        }
        return this.instance;
    }

    setEnv(){
        let appVars = AppVars.getInstance()
        this.currentEnv = appVars.getEnv();
    }

    log(envLevel, message){
        if (this.envRanking.indexOf(envLevel) >= this.envRanking.indexOf(this.currentEnv)){
            console.log(message)
        }
    }
}